import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  iconWrapper: {
    display: 'flex',
    justifyContent: 'center',
  },
  icon: {
    width: '100%',
  },
  formWrapper: {
    paddingTop: '2rem',
  },
  programDetails: {
    paddingTop: ({ isDeviceMdSize }) => (!isDeviceMdSize ? '2rem' : 0),
  },
  contractRiskAmountWrapper: {
    paddingRight: ({ isDeviceMdSize }) => (!isDeviceMdSize ? '2rem' : 0),
  },
  priceSection: {
    color: theme.palette.primary.main,
    fontSize: '1.75rem',
    fontWeight: 'bold',
    [theme.breakpoints.up('md')]: {
      borderRadius: '0px 0px 20px 20px',
      width: 247,
    },
    [theme.breakpoints.down('md')]: {
      height: '4.8rem',
    },
  },
  amountWrapper: {
    margin: '0.5rem 0',
    textAlign: 'center',
    fontSize: 28,
    display: 'flex',
    justifyContent: 'center',
    height: '1.75rem',
    [theme.breakpoints.down('sm')]: {
      fontSize: 20,
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: 14,
    },
  },
  textWrapper: {
    padding: 0,
    margin: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
  },
  text: {
    lineHeight: '1.4rem',
    fontWeight: 'normal',
    width: '100%',
    fontSize: 16,
    [theme.breakpoints.down('sm')]: {
      fontSize: 14,
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: 12,
    },
  },
}));

export default useStyles;
